import { TestLayerLabel, TestLayerValue } from '@nrwl/common-lib';

export const BertConfigFieldMapping = {
  //setup
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  TECHINICIAN: 'technician',
  TECHINICIANID: 'technicianId',
  COMMENTS:'comments',
  ENGINE_A_INFO: 'engine-a-info',
  ENGINE_B_INFO: 'engine-b-info',
  TEST_MODE: 'mode',
  LAYER_TO_TEST: 'layer',
  BERT_PATTERN: 'bert-pattern',
  IP_ADDRESS_TYPE: 'ip-address-type',
  STREAM_RATE_CONVENTION: 'unit-convention',
  RUN_PERF_TEST: 'run-perf-test',
  BERT_TEST_DURATION: 'bert-test-duration',
  BERT_TEST_CUSTOM_DURATION: 'perf-test-custom-duration',
  NUMBER_OF_STEPS: 'number-of-steps',
  RUN_CONFIG_TEST: 'run-config-test',
  STEP_DURATION: 'step-duration',
  STEP_PERCENTS: 'step-percents',
  REVERSE_STEPS: 'ramp-up',
  ABORT_ON_FAILURE: 'abort-on-failure',
  RUN_TYPE: 'runType',
  SCHEDULER: 'scheduler',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_DESTINATION: 'selectedDestination',

  //endpoints
  AGENT_TYPE: 'agentType',
  FRAME_LOSS_INTERVAL: 'frame-loss-interval',
  DEFINED_ADDRESS: 'definedAddress',
  SOURCE_ADDRESS_FROM: 'sourceAddress',
  SUPPRESS_LOOP_COMMANDS: 'suppress-loop-commands',
  SWAP_MAC_ADDRESS: 'swap-addresses',
  SEND_PRIMING_PACKETS: 'send-priming-packets',
  VLAN_CONFIG: 'vlanConfig',
  ETHER_TYPE: 'ether-type',
  CVLAN_ETHER_TYPE: 'inner-ether-type',
  VLAN_ENABLED: 'vlanEnabled',
  SVLAN_ID: 'vlan-id',
  CVLAN_ID: 'inner-vlan-id',
  VERIFY_PRIORITY: 'filter-on-priority',
  VLAN_DEFINED: 'vlanDefinedForEachService',
  ETHER_TYPE_DEFINED: 'etherTypeDefinedForEachService',
  SRC_EDIT_LAYER_2_IP: 'srcEditLayer2IP',
  SRC_EDIT_LAYER_3_IP: 'srcEditLayer3IP',
  SRC_EDIT_LAYER_2_MAC: 'srcEditLayer2MAC',
  SRC_EDIT_LAYER_3_MAC: 'srcEditLayer3MAC',
  SRC_MAC_ADDRESS: 'source-mac',
  SRC_NETWORK_MAC: 'srcNetworkMacAddress',
  SRC_EQUIPMENT_MAC: 'srcEquipmentMacAddress',
  SRC_TEST_IP_ADDRESS: 'srcTestIpAddress',
  SRC_ASSIGNED_IP_ADDRESS: 'srcAssignedIpAddress',
  SRC_IPV4_ADDRESS: 'test-ip',
  SRC_IPV6_ADDRESS: 'source-ipv6-address',
  SRC_SUBNET: 'test-subnet-mask',
  SRC_GATEWAY: 'test-gateway',
  TRANSMIT_INTERFACE: 'tx-interface',
  DEST_EDIT_IP: 'destEditIP',
  DEST_EDIT_MAC: 'destEditMAC',
  DEST_IPV4_ADDRESS: 'destination-ip',
  DEST_TRANSMIT_INTERFACE: 'dest-tx-interface',
  DEST_DEFINED_ADDRESS: 'dest-definedAddress',
  REMOTE_VLAN_TAG: 'remote-tag-count',
  DEST_SHOW_IP_LAYER2: 'destShowIpWithLayer2',
  DEST_SHOW_MAC_LAYER3: 'destShowMacWithLayer3',
  USE_ARP: 'arp-mode',
  DESTINATION_MAC: 'destination-mac',
  DEI_ENABLE: 'deiEnable',

  //streams
  STREAMS: 'streams',
  STREAM_NUMBER: 'stream-number',
  STREAM_NAME: 'name',
  ULR: 'ulr-from-engine-a',
  BER_THRESHOLD: 'ber-threshold',
  FD: 'frame-delay-threshold',
  ENABLE_FRAME_DELAY: 'enable-frame-delay',
  FDV: 'latency-FDV-maximum',
  LOSS: 'frame-loss-ratio-threshold',
  VALID_FRAME_SIZE: 'validFrameSizes',
  VALID_FRAME_SIZE_SINGLE: 'validFrameSizesSingle',
  VALID_FRAME_SIZE_DOUBLE: 'validFrameSizesDouble',
  BERT_FRAME_SIZE: 'bert-frame-size-list',
  SVLAN_PRIORITY: 'vlan-priority',
  CVLAN_PRIORITY: 'inner-vlan-priority',
  ERROR_ON_OOS: 'fail-on-OOS',
  MAX_SERVICES: 'maxServices',
  DSCP: 'dscp',
  TTL: 'ttl',
  TOS: 'tos',
  OVER_HEAD_BYTES: 'overhead-byte-count',
  MAX_BANDWIDTH: 'max_bandwidth',
  DEVICE_SELECTION_METHOD: 'device-selection-method',
  FRAME_LENGTH: 'frame-length',
  FRAME_TYPE: 'frame_type',
  FRAME_LIST: 'frame-list'
};

export enum IPAddressLabel {
  IP_V4 = 'IPv4',
  IP_V6 = 'IPv6'
}

export enum IPAddressValue {
  IP_V4 = 'ipv4',
  IP_V6 = 'ipv6'
}

export enum streamRateConventionLabel {
  L1 = 'L1 Mbps (ULR)',
  L2 = 'L2 Mbps (IR)'
}

export enum streamRateConventionValue {
  L1 = 'l1-mbps',
  L2 = 'l2-mbps'
}

export enum frameLossIntervalLabel {
  peak = 'Peak 1 second',
  overall = 'Overall test'
}

export enum frameLossIntervalValue {
  peak = 'peak',
  overall = 'overall'
}

export enum definedAddressLabel {
  TEST_IP = 'Test IP',
  MANAGEMENT_IP = 'Management IP',
  MANUAL = 'Manual'
}

export enum definedAddressValue {
  TEST_IP = 'testIP',
  MANAGEMENT_IP = 'managed',
  MANUAL = 'manual'
}

export enum sourceAddressFrom {
  MANUAL = 'manual',
  DHCP = 'DHCP'
}

export enum vlanConfigLabel {
  UNTAGGED = 'Untagged',
  SINGLE_VLAN = 'Single VLAN',
  Q_IN_Q = 'Q-in-Q'
}

export enum vlanConfigValue {
  UNTAGGED = 'untagged',
  SINGLE_VLAN = 'tagged',
  Q_IN_Q = 'q_in_q'
}

export enum TRANSMIT_INTERFACE_LABEL {
  EQUIPMENT = 'Equipment',
  NETWORK = 'Network'
}

export enum TRANSMIT_INTERFACE_VALUE {
  EQUIPMENT = 'equipment',
  NETWORK = 'network'
}

export enum TX_IMAGE {
  EQUIPMENT = 'images/equipment.png',
  NETWORK = 'images/network.png'
}

export enum PAYLOAD_TYPE_LABEL {
  FILL = 'Fill byte',
  PRBS = 'PRBS'
}

export enum PAYLOAD_TYPE_VALUE {
  FILL = 'fill-byte',
  PRBS = 'prbs'
}

export enum ETHER_TYPE_LABEL {
  ETHER_8100 = '8100',
  ETHER_88a8 = '88a8',
  ETHER_9100 = '9100'
}

export const IP_ADDRESS_TYPE = [
  { name: IPAddressLabel.IP_V4, value: IPAddressValue.IP_V4 },
  { name: IPAddressLabel.IP_V6, value: IPAddressValue.IP_V6 }
];

export const STREAM_RATE_TYPE = [
  { name: streamRateConventionLabel.L2, value: streamRateConventionValue.L2 },
  { name: streamRateConventionLabel.L1, value: streamRateConventionValue.L1 }
];

export const FRAME_LOSS_TYPE = [
  { name: frameLossIntervalLabel.peak, value: frameLossIntervalValue.peak },
  { name: frameLossIntervalLabel.overall, value: frameLossIntervalValue.overall }
];

export const VLAN_CONFIG_TYPE = [
  { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
  { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
  { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
];

export const SVLAN_ETHER_TYPE = [
  { name: ETHER_TYPE_LABEL.ETHER_8100, value:ETHER_TYPE_LABEL.ETHER_8100, vlanType:vlanConfigValue.SINGLE_VLAN},
  { name: ETHER_TYPE_LABEL.ETHER_88a8, value:ETHER_TYPE_LABEL.ETHER_88a8, vlanType:vlanConfigValue.Q_IN_Q}
];

export const CVLAN_ETHER_TYPE = [{ name: '8100', value: '8100' }];

export const TRANSMIT_INTERFACE_TYPE = [
  { name: TRANSMIT_INTERFACE_LABEL.EQUIPMENT, value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT },
  { name: TRANSMIT_INTERFACE_LABEL.NETWORK, value: TRANSMIT_INTERFACE_VALUE.NETWORK }
];

export const PAYLOAD_TYPE = [
  { name: PAYLOAD_TYPE_LABEL.FILL, value: PAYLOAD_TYPE_VALUE.FILL },
  { name: PAYLOAD_TYPE_LABEL.PRBS, value: PAYLOAD_TYPE_VALUE.PRBS }
];

export const CONFIRM_SELECTION = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];

export const LOOP_UP_SELECTION = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];

export const REVERSE_CONFIRM_SELECTION = [
  { name: 'Yes', value: false },
  { name: 'No', value: true }
];

export const BERT_PATTERN_SELECTION = [
  { name: '2^31-1', value: '2^31-1' },
  { name: '2^31-1 Inverted', value: '2^31-1 inverted' }
];

export const LAYER_TYPES = [
  { name: TestLayerLabel.L2, value: TestLayerValue.L2 },
  { name: TestLayerLabel.L3, value: TestLayerValue.L3 }
];

export const MTS_LAYER_TYPES = [{ name: TestLayerLabel.L4, value: TestLayerValue.L4 }];

export const ERROR_ON_OOS = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];

export const DSCP_CONFIG_TYPE = [
  {
    value: 'Best effort (0)',
    id: 0
  },
  {
    value: 'Class Selector 1 (8)',
    id: 32
  },
  {
    value: 'AF 11 (10)',
    id: 40
  },
  {
    value: 'AF 12 (12)',
    id: 48
  },
  {
    value: 'AF 13 (14)',
    id: 56
  },
  {
    value: 'Class Selector 2 (16)',
    id: 64
  },
  {
    value: 'AF 21 (18)',
    id: 72
  },
  {
    value: 'AF 22 (20)',
    id: 80
  },
  {
    value: 'AF 23 (22)',
    id: 88
  },
  {
    value: 'Class Selector 3 (24)',
    id: 96
  },
  {
    value: 'AF 31 (26)',
    id: 104
  },
  {
    value: 'AF 32 (28)',
    id: 112
  },
  {
    value: 'AF 33 (30)',
    id: 120
  },
  {
    value: 'Class Selector 4 (32)',
    id: 128
  },
  {
    value: 'AF 41 (34)',
    id: 136
  },
  {
    value: 'AF 42 (36)',
    id: 144
  },
  {
    value: 'AF 43 (38)',
    id: 152
  },
  {
    value: 'Class Selector 5 (40)',
    id: 160
  },
  {
    value: 'AF 51 (42)',
    id: 168
  },
  {
    value: 'AF 52 (52)',
    id: 176
  },
  {
    value: 'Exp. Forwarding (46)',
    id: 184
  },
  {
    value: 'Class Selector 6 (48)',
    id: 192
  },
  {
    value: 'Class Selector 7 (56)',
    id: 224
  }
];

export const SVLAN_PRIORITY_TYPE = [
  {
    value: 'Pri-0',
    id: 0
  },
  {
    value: 'Pri-1',
    id: 1
  },
  {
    value: 'Pri-2',
    id: 2
  },
  {
    value: 'Pri-3',
    id: 3
  },
  {
    value: 'Pri-4',
    id: 4
  },
  {
    value: 'Pri-5',
    id: 5
  },
  {
    value: 'Pri-6',
    id: 6
  },
  {
    value: 'Pri-7',
    id: 7
  }
];
export const CVLAN_PRIORITY_TYPE = [
  {
    value: 'Pri-0',
    id: 0
  },
  {
    value: 'Pri-1',
    id: 1
  },
  {
    value: 'Pri-2',
    id: 2
  },
  {
    value: 'Pri-3',
    id: 3
  },
  {
    value: 'Pri-4',
    id: 4
  },
  {
    value: 'Pri-5',
    id: 5
  },
  {
    value: 'Pri-6',
    id: 6
  },
  {
    value: 'Pri-7',
    id: 7
  }
];

export const DEFINED_ADDRESS_TYPES = [
  { name: definedAddressLabel.TEST_IP, value: definedAddressValue.TEST_IP, enabled: true },
  {
    name: definedAddressLabel.MANAGEMENT_IP,
    value: definedAddressValue.MANAGEMENT_IP,
    enabled: true
  },
  { name: definedAddressLabel.MANUAL, value: definedAddressValue.MANUAL, enabled: true }
];

export const SOURCE_ADDRESS_FROM = [
  { name: 'Manual', value: sourceAddressFrom.MANUAL },
  { name: 'DHCP', value: sourceAddressFrom.DHCP }
];

export const SUBNET_MAP = {
  '1': '128.0.0.0',
  '2': '192.0.0.0',
  '3': '224.0.0.0',
  '4': '240.0.0.0',
  '5': '248.0.0.0',
  '6': '252.0.0.0',
  '7': '254.0.0.0',
  '8': '255.0.0.0',
  '9': '255.128.0.0',
  '10': '255.192.0.0',
  '11': '255.224.0.0',
  '12': '255.240.0.0',
  '13': '255.248.0.0',
  '14': '255.252.0.0',
  '15': '255.254.0.0',
  '16': '255.255.0.0',
  '17': '255.255.128.0',
  '18': '255.255.192.0',
  '19': '255.255.224.0',
  '20': '255.255.240.0',
  '21': '255.255.248.0',
  '22': '255.255.252.0',
  '23': '255.255.254.0',
  '24': '255.255.255.0',
  '25': '255.255.255.128',
  '26': '255.255.255.192',
  '27': '255.255.255.224',
  '28': '255.255.255.240',
  '29': '255.255.255.248',
  '30': '255.255.255.252',
  '31': '255.255.255.254',
  '32': '255.255.255.255'
};

export const PERF_TEST_DURATIONS = [
  { name: '1 minute', value: 60 },
  { name: '15 minutes', value: 900 },
  { name: '2 Hours', value: 7200 },
  { name: '24 Hours', value: 86400 },
  { name: 'User Defined', value: 'custom' }
];

export const BER_THRESHOLD_TYPES = [
  { name: '0.00', value: '0.00' },
  { name: '1.00E-6', value: '1.00E-6' },
  { name: '1.00E-9', value: '1.00E-9' },
  { name: '1.00E-12', value: '1.00E-12' }
];

export const DEFAULT_STREAM = [
  {
    'stream-number': 1,
    name: 'BERT 2^31-1',
    'ulr-from-engine-a': 10,
    'frame-loss-ratio-threshold': 0,
    'ber-threshold': '0.00',
    'latency-FDV-maximum': 100,
    'frame-delay-threshold': 100,
    'bert-frame-size-list': '512',
    'fail-on-OOS': true,
    'vlan-priority': 0,
    'inner-vlan-priority': 0,
    'filter-on-tos': false,
    'overhead-byte-count': 0,
    //ipv4
    tos: 184,
    ttl: 32
  }
];

export const LoopbackTypes = {
  L2_LOOPBACK: 'l2-loopback',
  L3_IPV4_LOOPBACK: 'l3-ipv4-loopback'
};
